/* import __COLOCATED_TEMPLATE__ from './action-history-list.hbs'; */
import { A } from '@ember/array';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-action-history-list';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  /**
   * NAMED TO AVOID COLLISION WITH Ember 'actions' paradigm
   * @type {Ember.A<Action>}
   */
  actionModels: A([]),

  _now: Date.now(),
});
